
import React, { useState } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Eye, EyeOff } from 'lucide-react';

interface InternalPinSectionProps {
  pin: string;
  confirmPin: string;
  onPinChange: (pin: string) => void;
  onConfirmPinChange: (confirmPin: string) => void;
}

const InternalPinSection = ({ 
  pin, 
  confirmPin, 
  onPinChange, 
  onConfirmPinChange 
}: InternalPinSectionProps) => {
  const [showPin, setShowPin] = useState(false);
  const [showConfirmPin, setShowConfirmPin] = useState(false);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="pin" className="text-white">PIN</Label>
        <div className="relative">
          <Input
            id="pin"
            type={showPin ? 'text' : 'password'}
            value={pin}
            onChange={(e) => onPinChange(e.target.value)}
            className="bg-gray-900 border-gray-700 text-white pr-12"
            placeholder="Enter 4+ digit PIN"
            required
          />
          <button
            type="button"
            onClick={() => setShowPin(!showPin)}
            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-white"
          >
            {showPin ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="confirmPin" className="text-white">Confirm PIN</Label>
        <div className="relative">
          <Input
            id="confirmPin"
            type={showConfirmPin ? 'text' : 'password'}
            value={confirmPin}
            onChange={(e) => onConfirmPinChange(e.target.value)}
            className="bg-gray-900 border-gray-700 text-white pr-12"
            placeholder="Confirm PIN"
            required
          />
          <button
            type="button"
            onClick={() => setShowConfirmPin(!showConfirmPin)}
            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-white"
          >
            {showConfirmPin ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InternalPinSection;
